//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getNomenclatureImage from '@/pages/sale/new-design/utils/getNomenclatureImage';
import BasketItemTag from './basketItemTag';
export default {
  components: {
    BasketItemTag,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      const item = this.item;
      return getNomenclatureImage({ vm: this, product: item });
    },
  },
  methods: {
    remove(item) {
      this.debug({ name: 'remove' }, 'item = %O', item);

      this.$emit('remove', item);
    },
  },
};
